// extracted by mini-css-extract-plugin
export default {"card":"SurveyCampaignPage_card__oaaK1","row":"SurveyCampaignPage_row__Ul+Tm","selected":"SurveyCampaignPage_selected__BqykZ"};